/* eslint-disable no-var */

// ====================================
// Please don't add items to this list.
// ====================================
//
// Moving forward please use:
// export const NEW_ACTION = 'NEW_ACTION'
// in `js/actions/whatever.js` See `js/actions/offline.js` for an example
//
// ESLint can't detect a typo in `ACTIONS.NEW_ACION`, you just end up with an
// action with `{ type: undefined }` at runtime. If you define the constant in
// your action creator file `NEW_ACION` gets flagged as an undefined variable.
// When you go to `import { NEW_ACION } ...` in the reducer, ESLint will tell
// you that isn't being exported
export const ACTIONS = {
    NOOP: 'NOOP',
    ADD_CONTENT_TO_COLLECTION: 'ADD_CONTENT_TO_COLLECTION',
    REMOVE_CONTENT_FROM_COLLECTION: 'REMOVE_CONTENT_FROM_COLLECTION',
    DELETE_COLLECTION: 'DELETE_COLLECTION',
    CREATE_COLLECTION: 'CREATE_COLLECTION',
    DELETE_CONTENT: 'DELETE_CONTENT',
    SYNC_TERM: 'SYNC_TERM',
    CURRENT_TERM: 'CURRENT_TERM',
    NEW_NOTIFICATION: 'NEW_NOTIFICATION',
    REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
    UPDATE_SELECTIONS: 'UPDATE_SELECTIONS',
    UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
    OPEN_PUSHMENU: 'OPEN_PUSHMENU',
    CLOSE_PUSHMENU: 'CLOSE_PUSHMENU',
    TOGGLE_PUSHMENU: 'TOGGLE_PUSHMENU',
    MERGE_PREFERENCES: 'MERGE_PREFERENCES',
    ADD_CONTENT: 'ADD_CONTENT',
    SET_CONTENT_SETTINGS: 'SET_CONTENT_SETTINGS',
    SYNC_CUSTOMER: 'SYNC_CUSTOMER',
    SYNC_SECTION: 'SYNC_SECTION',
    SYNC_USER: 'SYNC_USER',
    SYNC_PREFERENCES: 'SYNC_PREFERENCES',
    SYNC_CSRF: 'SYNC_CSRF',
    SYNC_MEMBERSHIP: 'SYNC_MEMBERSHIP',
    SYNC_AUTH_CODE: 'SYNC_AUTH_CODE',
    SET_CONTENT: 'SET_CONTENT',
    CLEAR_CONTENT: 'CLEAR_CONTENT',
    SET_ORIGIN: 'SET_ORIGIN',
    ADD_AURAL_NOTIFICATION: 'ADD_AURAL_NOTIFICATION',
    REMOVE_AURAL_NOTIFICATION: 'REMOVE_AURAL_NOTIFICATION',
    SET_SKIP_LINK: 'SET_SKIP_LINK',
    CLEAR_SKIP_LINK: 'CLEAR_SKIP_LINK',
};

export const KEYS = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    SPACE: 32,
    PAGEUP: 33,
    PAGEDOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    INSERT: 45,
    DELETE: 46,
    P: 80,
};

export const FOCUSABLE_ELEMENTS = [
    'a',
    'area',
    'input',
    'select',
    'textarea',
    'button',
    'iframe',
    '[role="button"]',
    '[role="tab"]',
];

// For backward compatibility
export default {
    ACTIONS,
    KEYS,
    FOCUSABLE_ELEMENTS,

    ANALYTICS: {
        URL: '/api/insight/',
        HELP_URL: 'https://resources.unizin.org/display/EKB/Using+Analytics',
    },
    API: {
        DEFAULT: '/api/v3',
        V2: '/api',
        V3: '/api/v3',
    },
    ERROR: {
        NO_CONTENT: 'Unable to find',
    },
    HELP: {
        URL: 'https://resources.unizin.org',
    },
    NAVBAR: {
        TITLE: 'Engage',
        ZINDEX: 1030,
    },
    ZOOM: {
        CLASSNAME: 'zoomed',
        DEFAULT_WIDTH: 100,
        MAX: 200,
        MIN: 50,
        STEP: 10,
    },
};

export const TAGNAMES = {
    INPUT: 'INPUT',
    TEXTAREA: 'TEXTAREA',
};

export const ICONS = {
    FAIL: 'FAIL',
    SUCCESS: 'SUCCESS',
    CANCEL: 'CANCEL',
};



// WEBPACK FOOTER //
// ./src/const.js